@file:OptIn(InternalResourceApi::class)

package mica.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mica.composeapp.generated.resources/"

internal val Res.drawable.ic_play: DrawableResource by lazy {
      DrawableResource("drawable:ic_play", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_play.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_play", Res.drawable.ic_play)
}
